import * as types from './types';

export const setDefaultBuilding = (building) => ({
  type: types.SET_DEFAULT_BUILDING,
  payload: building
});